import { client } from '..';
import { QAResponse } from '../models/questionAnswerModels';

export const askQuestion = async ({
  question,
  fromEmail,
  nonProfitOrgId,
  programId,
  volunteerId,
  amenityId
}: {
  question: string;
  fromEmail: string;
  nonProfitOrgId: string;
  programId?: string;
  volunteerId?: string;
  amenityId?: string;
}): Promise<any> => {
  const { data } = await client.post('/questions-answers/ask', {
    question,
    fromEmail,
    nonProfitOrgId,
    programId,
    volunteerId,
    amenityId
  });
  return data;
};

export const getAskQuestionList = async ({ npoId }: { npoId: string }): Promise<QAResponse[]> => {
  const url = `/questions-answers?npo=${npoId}`;
  const { data } = await client.get(url);

  return data;
};

export const createQuestionAnswer = async ({
  question,
  answer,
  nonProfitOrgId
}: {
  question: string;
  answer: string;
  nonProfitOrgId: string;
}): Promise<QAResponse> => {
  const { data } = await client.post('questions-answers', {
    question,
    answer,
    nonProfitOrgId
  });
  return data;
};
